import React from 'react';
import Modal from '@material-ui/core/Modal';
import DetailsCard from './DetailsCard';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: '10vh',
    left: 0,
    right: 0,
    width: '90%',
    maxWidth: '400px',
    // maxHeight: '80vh',
    margin: 'auto',
    marginBottom: '20px'
  },
  modalScrollArea: {
    position: 'relative',
    marginBottom: '10',
    maxHeight: '63vh',
    overflowY: 'auto'
  },
});

const DetailsCardModal = (props) => {

  const { classes, appLanguage  } = props;
  

  return (
    <Modal
      aria-labelledby={props.ariaLabelledby}
      aria-describedby={props.ariaDescribedby}
      open={props.open}
      onClose={props.onClose}
      BackdropProps={props.backdropProps}
    >
      <div>
        <DetailsCard
          className={classes.paper}
          // classes={classes}
          appLanguage={appLanguage}
          title={props.title}
          subheader={props.subheader}
          onClose={props.onClose}
          cardStyles={{height: 'auto'}}
          contentStyles={{maxHeight: '63vh'}}
          >
            {props.children}
        </DetailsCard>
      </div>
    </Modal>
  );
}

export default withStyles(styles)(DetailsCardModal);


// WEBPACK FOOTER //
// ./src/components/containers/DetailsCardModal.js